const calRem = (size) => `${size / 16}rem`;

const fontSize = {
  //  ex
  //   status: calRem(8),
  //   xs: calRem(12),
  //   sm: calRem(14),
};

const fontWeight = {
  // ex
  //   black: 900,
  //   extraBold: 800,
};

const color = {
  // ex
  //   brandColor: '#FF9900',
  //   skyblue: '#D4F0FF',
  //   bgColor: '#F8F8F8',
  black : "#000000",
  white : "#ffffff",
  orange : "#FF7A00",
  gray50 : "#F8F9FA",
  gray100 : "#F1F3F5",
  gray300 : "#DFE2E6",
  gray600 : "#878E95",
  gray700 : "#4A5056",
  gray900 : "#222529",
};

const deviceSize = {
  // ex
  //   mobile: '(max-width: 395px)',
  //   tablet: '(min-width: 600px)',
};

const theme = {
  fontSize,
  fontWeight,
  color,
  deviceSize,
};

export default theme;
